import { ComponentAPI } from '../../../api/genericLayout/ComponentAPI';

export class BackgroundStyleCommand {
    constructor(appName) {
        this.componentApi = new ComponentAPI(appName);
    }

    getAvailableTargets(componentType, successCallback, errorCallback) {
        const apiResult = this.componentApi.listBackgroundTargets(componentType);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter os elementos disponíveis para configuração de um fundo");
            }
        });
    }
}
